export function sum(arr: number[]): number {
    let total = 0
    for (const i of arr) {
        total += i
    }
    return total
}

export function meanAvg(arr: number[]): number {
    return sum(arr) / arr.length
}

export function round(value: number, decimalPlaces: number): number {
    const factor = Math.pow(10, decimalPlaces)
    return Math.round((value + Number.EPSILON) * factor) / factor
}
